import { render, staticRenderFns } from "./SubmissionEditorCardLegacy.vue?vue&type=template&id=82f622c8&scoped=true"
import script from "./SubmissionEditorCardLegacy.vue?vue&type=script&lang=js"
export * from "./SubmissionEditorCardLegacy.vue?vue&type=script&lang=js"
import style0 from "./SubmissionEditorCardLegacy.vue?vue&type=style&index=0&id=82f622c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82f622c8",
  null
  
)

export default component.exports